import i18n from '@cdo/locale';

const Applab = {
  scriptName: 'applab-intro',
  link: '/s/applab-intro/reset',
  image: 'applab-tutorial',
  buttonText: i18n.applabTutorialButton(),
};

const CourseB = {
  scriptName: 'courseb',
  link: '/s/courseb',
  image: 'courseB',
  buttonText: i18n.viewCourse(),
};

const CourseC = {
  scriptName: 'coursec',
  link: '/s/coursec',
  image: 'courseC',
  buttonText: i18n.viewCourse(),
};

const CourseD = {
  scriptName: 'coursed',
  link: '/s/coursed',
  image: 'courseD',
  buttonText: i18n.viewCourse(),
};

const CourseE = {
  scriptName: 'coursee',
  link: '/s/coursee',
  image: 'courseE',
  buttonText: i18n.viewCourse(),
};

const CourseF = {
  scriptName: 'coursef',
  link: '/s/coursef',
  image: 'courseF',
  buttonText: i18n.viewCourse(),
};

export const nextLevelCourseCards = [
  Applab,
  CourseB,
  CourseC,
  CourseD,
  CourseE,
  CourseF,
];

export const defaultNextLevelCourseCard = Applab;
